import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalService } from '../shared/services/modal.service';
import { AdobeLaunchService } from '../shared/services/adobe-launch.service';

@Component({
  selector: 'materials',
  templateUrl: './materials.component.html',
  styleUrls: ['./materials.component.scss']
})
export class MaterialsComponent implements OnInit {
  constructor(
    public modalService: ModalService,
    private readonly adobeLaunchService: AdobeLaunchService
  ) {}

  @ViewChild('materialsk1')
  materialsk1Section!: ElementRef;

  @ViewChild('materials23')
  materials23Section!: ElementRef;

  @ViewChild('materials45')
  materials45Section!: ElementRef;

  @ViewChild('materials6')
  materials6Section!: ElementRef;

  @ViewChild('materials78')
  materials78Section!: ElementRef;

  @ViewChild('materials910')
  materials910Section!: ElementRef;

  @ViewChild('materials1112')
  materials1112Section!: ElementRef;

  @ViewChild('videoMaterials')
  videoMaterialsSection!: ElementRef;

  ngOnInit(): void {
    document.documentElement.classList.add('default-font-size');
    this.adobeLaunchService.trackPageView({
      pageTitle:'Classroom Materials'
    });
  }

  onSidebarNavClick(elementName: string): void {
    const sectionMap: { [key: string]: ElementRef } = {
      materialsk1: this.materialsk1Section,
      materials23: this.materials23Section,
      materials45: this.materials45Section,
      materials6: this.materials6Section,
      materials78: this.materials78Section,
      materials910: this.materials910Section,
      materials1112: this.materials1112Section,
      videoMaterials: this.videoMaterialsSection,
    };
  
    const targetSection = sectionMap[elementName];
    if (targetSection) {
      setTimeout(() => {
        targetSection.nativeElement.focus({ preventScroll: true });
      }, 0);
    }
  }
}
